<ppl-top-bar *ngIf="isTopBarVisible">
  <ppl-top-navigation></ppl-top-navigation>
</ppl-top-bar>

<ppl-app-container>
  <ppl-loading-overlay *ngIf="showLoader$ | async"
                       [visible]="false"
                       [inverse]="false"
                       [large]="true"></ppl-loading-overlay>
  <div class="select-space-container">
    <div class="select-space-inner-container">
      <ppl-icon svgIcon="logo-coevera-white"
                width="243px"
                height="55px"></ppl-icon>
      <br>
      <div class="background-box">
        <h1 class="select-space-text"
            i18n="@@Select_your_working_space">Select your working space</h1>
        <div class="space-items">
          <ng-container *ngIf="(spaces$ | async).length > 0; else noSpaces">
            <ng-template #spacePicturePhantom>
              <div class="picture-phantom">
                <ppl-icon svgIcon="pipeline-phantom"
                          width="30px"
                          height="30px"></ppl-icon>
              </div>
            </ng-template>
            <a *ngFor="let space of spaces$ | async"
               href="{{space.appBaseUrl}}/space/{{space.id}}"
               class="space-item"
               (click)="onSpaceSelect(space)">
              <div class="space-item_inner">
                <div class="picture-container">
                  <div class="picture"
                       [class.picture--no-picture]="!space.pictureUrl">
                    <img *ngIf="space.pictureUrl; else spacePicturePhantom"
                         src="{{space.pictureUrl}}"
                         alt="{{space.name}}"
                         title="{{space.name}}">
                    @if (!canAccessSpace(space)) {
                      <div class="space-item_badge space-item_badge--error"
                           title="Expired"
                           i18n-title="@@Expired"
                           i18n="@@Expired">Expired</div>
                    } @else {
                      @if (isLoginRequired(space) || isSessionReloginRequired(space)) {
                        <div class="space-item_badge space-item_badge--warning"
                             title="Login Required"
                             i18n-title="@@Login_Required"
                             i18n="@@Login_Required">Login Required</div>
                      } @else if (isTwoStepVerificationNeeded(space)) {
                        <div class="space-item_badge space-item_badge--warning"
                             title="2-Step Required"
                             i18n-title="@@2-Step_Required"
                             i18n="@@2-Step_Required">2-Step Required</div>
                      } @else if (isAccessFromRestrictedIP(space)) {
                        <div class="space-item_badge space-item_badge--error"
                             title="Access Restricted"
                             i18n-title="@@Access_Restricted"
                             i18n="@@Access_Restricted">Access Restricted</div>
                      }
                    }
                  </div>
                </div>
                <div class="title">
                  {{space.name}}
                </div>
                <div class="tier">
                  {{'EnumSubscriptionProductTier_' + space.subscription.productTier | t}}
                </div>
              </div>
            </a>
          </ng-container>
          <ng-template #noSpaces>
            <div class="no-space-text"
                 i18n="@@No_access!_You_are_not_member_of_any_team_space!">
              No access! You are not member of any team space!
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</ppl-app-container>
